// extracted by mini-css-extract-plugin
export default {"custom_nav":"NavLink_custom_nav__CqhE6","active":"NavLink_active__nL2N3"};